import {
  AddProductCardFieldName,
  AddProductCardListField,
  AddProductField,
  Allergens,
  FieldMap,
  IFormServiceAddProductCard,
  IFormServiceProductCard,
} from "@forms/schema";

const productAllergies: Record<AddProductCardFieldName, Allergens[]> = {
  sprinklesQuantity: [ "CHICKEN" ],
  nibblesChickenQuantity: [ "CHICKEN" ],
  nibblesSalmonQuantity: [ "SALMON" ],
  nibblesTrioBundleQuantity: [ "CHICKEN", "SALMON", "TUNA" ],
};

export const getAllCatAllergies = (fields?: FieldMap[]): Allergens[] => fields
  ?.filter((mappedField) => mappedField.key.fieldName === "catAllergies")
  .flatMap((mappedAllergies) => {
    const value = mappedAllergies.data.submitValue as Allergens | Allergens[] | undefined;
    return Array.isArray(value) ? value : [ value ];
  })
  .filter((mappedAllergy): mappedAllergy is Allergens => mappedAllergy !== undefined) ?? [];

export const getAddProductCardListProductsToDisplay = (
  field: AddProductCardListField,
  flowFields: FieldMap[] | undefined,
): IFormServiceAddProductCard[] => {
  const allergies = getAllCatAllergies(flowFields);
  const withoutAllergies = field.products.filter(
    (product) => !allergies.some(
      (allergy) => productAllergies[product.fieldName].includes(allergy),
    ),
  );
  const hiddenProducts = withoutAllergies.filter((product) => product.hidden);
  if (field.max_to_show) {
    return [ ...withoutAllergies.slice(0, field.max_to_show), ...hiddenProducts ];
  }
  return [ ...withoutAllergies, ...hiddenProducts ];
};

export const getAddProductProductsToDisplay = (
  field: AddProductField,
  flowFields: FieldMap[] | undefined,
): IFormServiceProductCard[] => {
  const allergies = getAllCatAllergies(flowFields);
  return field.products
    .filter((product) => !allergies.some(
      (allergy) => productAllergies[product.field_name].includes(allergy),
    ))
    .filter((product) => !product.hidden);
};
